import { render, staticRenderFns } from "./MailPreferencesCard.vue?vue&type=template&id=ec067404"
import script from "./MailPreferencesCard.vue?vue&type=script&lang=js"
export * from "./MailPreferencesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports